$(document).ready(function () {
  //main-menu.liquid
  $(".megamenu-li").parent("ul").addClass("mega-menu");
  $(".menu-banner").parent("ul").addClass("banner-menu");
  $(".submenu-li").parent("ul").addClass("sub-menu");

  //testimonial.liquid
  $("#testimonial-slider").owlCarousel({
    loop: false,
    rewind: true,
    nav: true,
    margin: 30,
    navText: [
      '<i class="fa fa-angle-left"></i>',
      '<i class="fa fa-angle-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
        margin: 15,
      },
      479: {
        items: 1,
        margin: 15,
      },
      768: {
        items: 2,
      },
      979: {
        items: 2,
      },
      1199: {
        items: 2,
      },
    },
  });

  //blog-home.liquid
  $("#blog-slider").owlCarousel({
    loop: false,
    rewind: true,
    margin: 30,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
        margin: 15,
      },
      479: {
        items: 1,
        margin: 15,
      },
      768: {
        items: 2,
      },
      979: {
        items: 2,
      },
      1199: {
        items: 3,
      },
    },
  });

  //footer.liquid
  $(".variant-property [title]").removeAttr("title");

  //featured-product.liquid
  var swiper = new Swiper(".swiper-container#feture_pro_tab", {
    slidesPerView: 4,
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerColumn: 1,
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1199: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  //related-product.liquid
  $("#related-slider").owlCarousel({
    loop: false,
    rewind: true,
    margin: 30,
    nav: false,
    dots: false,
    autoplay: true,
    sautoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 2,
        margin: 15,
      },
      480: {
        items: 2,
      },
      768: {
        items: 3,
      },
      979: {
        items: 4,
      },
    },
  });

  $(".custom-add-cart").click(function () {
    var variant_id = $(this).parent(".qcart_wrap").attr("data-vid");
    var qty = $(this).parent().find(".quantity").val();
    addItemToCart(variant_id, qty);
  });


function addItemToCart(variant_id, qty) {
  data = {
    id: variant_id,
    quantity: qty,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (data) {
      $(".mini-cart").toggleClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      Shopify.getCart();
    },
  });
}
});